var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpandBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.16667L8 7.58333L1 14",
    stroke: "black",
    strokeWidth: 1.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandBlack);
export default __webpack_public_path__ + "static/media/Icon_Expand_Black.57e3fd6c14d222a7ad76e422f3f1e6ac.svg";
export { ForwardRef as ReactComponent };